export default "__VITE_ASSET__57870e3b__"